import Glide from '@glidejs/glide';

function init(el) {
  const carousel = new Glide(el, {
    perView: 1
  }).mount();
}

export default function() {
  const carousels = Array.from(document.querySelectorAll('.js-carousel'));
  if (!carousels.length) return;
  window.addEventListener('load', () => carousels.forEach(carousel => init(carousel)));
}
